import * as types from './mutation-types'

export const processBeganLoading = ({commit}) => {
    commit(types.LOADING_INC)
}

export const processFinishedLoading = ({commit}) => {
    commit(types.LOADING_DEC)
}